module.exports = __webpack_public_path__ + "img/xhy.red-150x150.df59a5fb.png";